import {
	ChangeDetectionStrategy,
	Component,
	effect,
	input,
	OnInit,
	output,
	signal,
} from '@angular/core';
import { EntityPriorityComponent } from '../../entity-priority/entity-priority.component';
import { IQuickEntityChipsData } from '@app/domain/types';
import { EntityResponsibleComponent } from '../../entity-responsible/entity-responsible.component';
import { EntityLabelsSectionComponent } from '../../entity-labels-section/entity-labels-section.component';
import { ILabel } from '@app/pages/settings/interfaces/labels.interfaces';
import { EntityCategoryComponent } from '../../entity-category/entity-category.component';
import { ICmmsAssignee } from '@app/pages/cmms/interfaces/assignee.interface';

@Component({
	selector: 'quick-entity-chips',
	imports: [
		EntityPriorityComponent,
		EntityResponsibleComponent,
		EntityLabelsSectionComponent,
		EntityCategoryComponent,
	],
	templateUrl: './quick-entity-chips.component.html',
	styleUrl: './quick-entity-chips.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuickEntityChipsComponent implements OnInit {
	initialChipValue = input<IQuickEntityChipsData>({
		priority: 2,
		assignee: null,
		labels: [],
		category: null,
	});
	quickChipChanged = output<IQuickEntityChipsData>();

	priority = signal<number>(this.initialChipValue().priority);
	assignee = signal<ICmmsAssignee>(this.initialChipValue().assignee);
	labels = signal<ILabel[]>(this.initialChipValue().labels);
	category = signal<string>(this.initialChipValue().category);

	ngOnInit() {
		this.priority.set(this.initialChipValue().priority);
		this.assignee.set(this.initialChipValue().assignee);
		this.labels.set(this.initialChipValue().labels);
		this.category.set(this.initialChipValue().category);
	}

	constructor() {
		effect(() => {
			this.quickChipChanged.emit({
				priority: this.priority(),
				assignee: this.assignee(),
				labels: this.labels(),
				category: this.category(),
			});
		});
	}
}
